// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"29515f8eaca209417f01","293":"7da663f6dc5db54da337","518":"81a8522dccbe97990b13","779":"88c37bcb128c71b5bd5a"}[chunkId] + ".js";
};